import React, {
	useContext, createContext, useState, useEffect, useMemo, useCallback,
} from 'react';
import propTypes from 'prop-types';
import { makeStyles } from '@material-ui/core';
import clsx from 'clsx';
import toastyGif from '../assets/toasty/toasty.gif';
import toastyWav from '../assets/toasty/toasty.wav';

const toastyContext = createContext();

export default function useToasty() {
	return useContext(toastyContext);
}

const useStyles = makeStyles(() => ({
	toasty: {
		pointerEvents: 'none',
		position: 'fixed',
		bottom: 0,
		right: -300,
		width: '20vh',
		height: '20vh',
		zIndex: 99,
		transition: 'right 300ms',
	},
	showToasty: {
		right: 0,
	},
}));

export function ToastyProvider(props) {
	const { children } = props;

	const classes = useStyles();

	const audio = useMemo(() => new Audio(toastyWav), []);
	const [show, setShow] = useState(false);

	useEffect(() => {
		if (!show) return () => {};

		audio.play();

		const timer = setTimeout(() => {
			setShow(false);
		}, 2000);

		return () => {
			clearTimeout(timer);
		};
	}, [show, audio]);

	const value = useCallback(() => setShow(true), []);

	return (
		<toastyContext.Provider value={value}>
			<img
				alt="toasty"
				src={toastyGif}
				className={clsx(classes.toasty, show && classes.showToasty)}
			/>
			{children}
		</toastyContext.Provider>
	);
}

ToastyProvider.propTypes = {
	children: propTypes.node.isRequired,
};
